<template>
    <div class="promotion-carousel">
        <div class="container">
            <div v-swiper:mySwiper="swiperOption">
                <div class="swiper-wrapper">
                    <div
                        class="swiper-slide"
                        v-for="(promotion, index) in promotions"
                        :key="index"
                    >
                        <img class="logo" :src="asset(promotion.promotion_logo_image_path)" v-if="promotion.promotion_logo_image_path">
                        <img class="banner" :src="asset(promotion.promotion_image_mobile_path)">
                        <p class="title" :style="{ color: promotion.promotion_description_color_right }">{{ promotion.promotion_title }}</p>
                    </div>
                </div>
            </div>

            <div class="swiper-pagination-main-block promotion-pagination">
                <div class="pagination-arrow prev">
                    <img class="pagination-icon" :src="asset('/images/icon_back.svg')">
                </div>
                <div class="pagination-arrow next">
                    <img class="pagination-icon" :src="asset('/images/icon_next.svg')">
                </div>
            </div>
        </div>

        <div class="swiper-pagination-block promotion-pagination">
            <div class="pagination-arrow prev">
                <img class="pagination-icon" :src="asset('images/chevron-left-grey.svg')">
            </div>
            
            <div class="swiper-pagination"></div>

            <div class="pagination-arrow next">
                <img class="pagination-icon" :src="asset('images/chevron-right-grey.svg')">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            promotions: {
                type: Array
            },
        },

        data() {
            return {
                swiperOption: {
                    pagination: {
                        el: '.promotion-pagination .swiper-pagination',
                        type: 'fraction'
                    },
                    navigation: {
                        nextEl: '.promotion-pagination .next',
                        prevEl: '.promotion-pagination .prev',
                    },
                    slidesPerView: 'auto',
                    spaceBetween: 12,
                    freeMode: true,

                    breakpoints: {
                        768: {
                            pagination: {
                                el: '.promotion-pagination .swiper-pagination',
                                clickable: true,
                                type: 'bullets'
                            },
                        },

                        1200: {
                            pagination: {
                                el: '.promotion-pagination .swiper-pagination',
                                clickable: true,
                                type: 'bullets'
                            },
                            spaceBetween: 30,
                            slidesPerView: 3,
                            slidesPerGroup: 3,
                            freeMode: false,
                            allowTouchMove: false,
                        },
                    }
                }
            }
        },
    }
</script>

<style lang="scss">
    @import '../../../sass/variables';

    * {
        :focus {
            outline: none;
        }
    }

    .promotion-carousel {
        margin-top: 20px;
        margin-bottom: 20px;
        overflow: hidden;

        @media ($md) {
            margin-top: 40px;
            margin-bottom: 21px;
        }

        .container {
            position: relative;
        }

        .swiper-container {
            overflow: visible;

            @media ($xl) {
                overflow: hidden;
            }

            .swiper-wrapper {
                .swiper-slide {
                    width: 73vw;

                    @media ($md) {
                        width: 40vw;
                    }

                    @media ($xl) {
                        width: 100%;
                        height: 350px;
                    }

                    .logo {
                        position: absolute;
                        top: 20px;
                        right: 20px;
                        height: 29px;

                        @media ($md) {
                            top: 30px;
                            height: 35px;
                        }
                    }

                    .banner {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .title {
                        position: absolute;
                        bottom: 3px;
                        font-family: $font-bold;
                        font-size: 24px;
                        margin-left: 25px;
                        margin-right: 25px;
                        line-height: 1.2;
                        white-space: pre-wrap;

                        @media ($md) {
                            margin-left: 30px;
                            font-size: 28px;
                        }
                    }
                }
            }
        }

        .swiper-pagination-main-block {
            display: none;

            @media ($md) {
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
                display: flex;
                justify-content: space-between;
                width: 100%;
                cursor: pointer;
            }

            .pagination-arrow {
                position: relative;
                transition: opacity .3s;

                &:hover {
                    opacity: .8;
                }

                &.prev {
                    left: -75px;
                }

                &.next {
                    right: -75px;
                }

                .pagination-icon {
                    width: 70px;
                    height: 53px;
                }
            }
        }

        .swiper-pagination-block {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;

            @media ($md) {
                margin-top: 20px;
            }

            .pagination-arrow {
                width: 60px;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                background-color: #e3e3e3;

                @media ($md) {
                    background-color: transparent;
                }

                .pagination-icon {
                    width: 15px;
                    height: 21px;
                }
            }

            .swiper-pagination {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                bottom: auto;

                &.swiper-pagination-fraction {
                    flex: 1 1 auto;
                    width: auto;
                    font-size: 30px;
                }

                .swiper-pagination-bullet {
                    border-radius: 0;
                    width: 40px;
                    height: 7px;
                    margin: 0 3.5px;

                    &-active {
                        background-color: $primary-red;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/motor-show/PromotionCarousel.vue